import ContentList from './ContentList'

export default ContentList
